import styled from '@emotion/styled';

/**
 * Organismo de layout: rejilla responsiva que coloca las `SettingsCard`.
 * Tres columnas en escritorio, dos en pantallas medianas y una en móvil.
 */
const SettingsGrid = styled.div({
  display: 'grid',
  gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
  gap: 22,
  maxWidth: 1120,
  '@media (max-width: 1100px)': { gridTemplateColumns: 'repeat(2, minmax(0, 1fr))' },
  '@media (max-width: 720px)': { gridTemplateColumns: '1fr' },
});

export default SettingsGrid;
